import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { AllNotificationsRead, NotificationDeleted, NotificationRead, NotificationReceived, NotificationsLoaded } from "./notifications.actions";
import _ from "lodash";
import StoneHedgeNotificationList from "./stoneHedgeNotificationList";

export default class StoneHedgeNotificationsReducer extends ReducerBase<StoneHedgeNotificationList> {

    constructor() {
        super();

        this.addHandler(NotificationsLoaded.EventName, this.handleNotificationsLoaded);
        this.addHandler(NotificationReceived.EventName, this.handleNotificationReceived);
        this.addHandler(NotificationRead.EventName, this.handleNotificationRead);
        this.addHandler(AllNotificationsRead.EventName, this.handleAllNotificationsRead);
        this.addHandler(NotificationDeleted.EventName, this.handleNotificationDeleted);
    }

    handleNotificationsLoaded(state: StoneHedgeNotificationList, event: NotificationsLoaded): StoneHedgeNotificationList {
        const newState = {
            ...state, 
            notifications: _.unionBy(event.notifications.data, state.notifications, m => m.id)
        };

        if (event.isUnread) {
            newState.unreadCount = event.notifications.totalCount;
        }
        else {
            newState.totalCount = event.notifications.totalCount;
        }
        return newState;
    }
    
    handleNotificationReceived(state: StoneHedgeNotificationList, event: NotificationReceived): StoneHedgeNotificationList {
        return {...state, notifications: _.unionBy([event.notification], state.notifications, m => m.id) };
    }

    handleNotificationRead(state: StoneHedgeNotificationList, event: NotificationRead): StoneHedgeNotificationList{
        return {
            ...state, 
            notifications: state.notifications.map(m => m.id === event.notification.id
                ? {...m, isRead: true}
                : m) 
        };
    }

    handleAllNotificationsRead(state: StoneHedgeNotificationList, event: AllNotificationsRead): StoneHedgeNotificationList {
        return {
            ...state, 
            notifications: state.notifications.map(m => ({...m, isRead: true}))
        };
    }

    handleNotificationDeleted(state: StoneHedgeNotificationList, event: NotificationDeleted): StoneHedgeNotificationList {        
        return {
            ...state, 
            notifications: state.notifications.filter(m => m.id !== event.notificationId)
        };
    }

    handleDefault(state: StoneHedgeNotificationList = initialState.notifications): StoneHedgeNotificationList {
        return state;
    }
}

